import React from "react";
import { makeStyles } from "@material-ui/core";

let useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        textAlign: 'center',
        flexDirection: 'column',
        margin:'70px auto',
        maxWidth:'100%'
    },
    gridDesc: {
        width: '50%',
        minWidth:700,
        maxWidth:'100%',
        margin: 'auto',
           [theme.breakpoints.down("800")]: {
            minWidth:'100%',
        },
    },
    desc: {
        margin: 0,
        fontSize:16,
    },
    gridBtns: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop:'25px',
        [theme.breakpoints.down("375")]: {
          flexDirection:'column',
          width:'100%',
          '& > button':{
            width:'90%'
          },
          '& > a':{
            width:'90%'
          }
        },
    },  
      btnRed: {
        margin: 5,
        [theme.breakpoints.down("375")]: {
            width:'100%',
            margin: 0,
          },
    },
    btnWhite: {
        margin: 5,
        padding:'0px 33.5px',
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridDesc']}>
                <p className={classes['desc']}>
                بورس انرژی بازاری است که مانند سایر بورس‌های کالایی، خریداران و فروشندگان زیادی در آن به‌منظور معامله حامل‌های انرژی یا اوراق بهادار مبتنی بر این کالاها حضور دارند و با انجام معاملات در بین آنها، قیمت این حامل‌ها به تعادل ‌می‌رسد. حامل‌های انرژی مانند نفت، گازوئیل، بنزین، حلالها،متانول، گاز، برق و...، کالاهایی هستند که قدرت انتقال انرژی را به صورت الکترونیکی یا شیمیایی دارند.بورس انرژی ایران به منظور نظم دادن به معاملات حامل‌های انرژی و دارایی‌های مبتنی بر این حامل‌ها، در سال 1384 جهت نظارت بر انجام معاملات و تسهیل فرآیند ثبت معاملات، تاسیس شده است.
                </p>
            </div>
            <div className={classes['gridBtns']}>
                {/* <a href="https://pouyan.ebgo.ir/StockCode" target={'_blank'}>
                <button type="" className={`${classes['btnRed']} btnPouyanRed`}>
                ثبت نام در بورس انرژی
                </button>
                </a> */}
                <button type="" className={`${classes['btnWhite']} btnPouyanWhite`}>
                    اطلاعات بیشتر
                </button>
            </div>
        </div>)
}
